import {
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { provideMarkdown } from 'ngx-markdown';

import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  API_URL,
  HUB_URL,
  REPORT_URL,
  APP_NAME,
  SHOW_ETHNIKI_LOGO,
  FraudTheme,
  JwtInterceptor,
  TranslationLoader,
} from 'shared-library';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    // provideHttpClient(withFetch()),
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'top',
      })
    ),
    provideAnimationsAsync(),
    provideMarkdown(),
    provideTranslateService({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslationLoader(http),
        deps: [HttpClient],
      },
    }),
    providePrimeNG({
      translation: { dateFormat: 'dd/mm/yy' },
      theme: {
        preset: FraudTheme,
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
    // { provide: API_URL, useValue: '/api/' },
    { provide: API_URL, useValue: environment.api },
    { provide: HUB_URL, useValue: environment.hub },
    { provide: REPORT_URL, useValue: environment.reportUrl },
    { provide: APP_NAME, useValue: 'coassess' },
    { provide: SHOW_ETHNIKI_LOGO, useValue: environment.showEthnikiLogo ?? false },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    // { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    // provideAppInitializer(() => inject(AppConfigService).loadConfig()),
  ],
};
